/* eslint-disable import/prefer-default-export */
import has from 'lodash/has';
import axios from 'axios';
import * as types from '../constants/ActionTypes';

// Helpers.
import { docTypeOptions } from '../../lib/customFields';
import { trackSetUp } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import {
  searchType, searchParser, getFullSearchCount, searchAnalytics,
} from '../../lib/insightHelper';
import getOpenDisputes from '../../home/actions/action-dispute-transactions';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

function requestArticleSearch() {
  return {
    type: types.REQUEST_ARTICLE_SEARCH,
    payload: undefined,
  };
}

function receiveArticleSearchResult(searchTerm, experience, responseData, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_RESPONSE,
    payload: {
      q: searchTerm,
      experience,
      items: responseData,
      channel: documentType,
    },
  };
}

function receiveArticleSearchError(searchTerm, experience, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_ERROR,
    payload: {
      q: searchTerm,
      experience,
      channel: documentType,
    },
  };
}

export const fetchArticleSearchResult = (searchTerm, experience, channel) => {
  const documentType = (has(docTypeOptions, channel)) ? channel : 'faq';
  const trackLinkOption = {
    id: 'searchPage',
    link: `smarthelp-search-filter-document-type|${documentType}|selfServiceSearch`,
    srch: searchTerm,
  };

  return (dispatch, getState) => {
    // shows loading spinner
    dispatch(requestArticleSearch());

    if (Page.isLoggedIn()) {
      // dispatching to get if any pending disputes exist so that we can display the message to user only when user is logged-in
      dispatch(getOpenDisputes());
    }

    const articleSearchUrl = `/smarthelp/km-full-search?q=${Page.getSanitizedValue(searchTerm)}&exp=${experience}&channel=${documentType}`;
    trackLinkOption.link = `smarthelp-search-filter-document-type|${documentType}|okmFullSearch`;

    return axios.get(articleSearchUrl, {
      cancelToken: source.token,
    })
      .then((response) => {
        // Speech to text search key identifier update
        const speechQuery = (getState().speechRecognition || {}).query;
        if (speechQuery) {
          trackLinkOption.srch = `${searchTerm}|speech`;
        }
        if (!response.data || !response.data.length) {
          // Dispatching error actions when API returns 200 with empty response
          trackLinkOption.id = 'searchErrorPage';
          trackLinkOption.link = `smarthelp-error-search|filter-type|${documentType}`;
          trackSetUp(trackLinkOption);
          dispatch(receiveArticleSearchError(searchTerm, experience, documentType));
          searchAnalytics(searchParser({
            count: 0, type: searchType.fullSearch, query: searchTerm, csrf: Page.getCSRFtoken(),
          }));
        } else {
          // Search Result page impression event
          trackSetUp(trackLinkOption);
          dispatch(receiveArticleSearchResult(searchTerm, experience, response.data, documentType));
          searchAnalytics(searchParser({
            count: getFullSearchCount(response.data), type: searchType.fullSearch, query: searchTerm, csrf: Page.getCSRFtoken(),
          }));
        }
      })
      .catch(() => {
        // Error impression event in the search result page
        trackLinkOption.id = 'searchErrorPage';
        trackLinkOption.link = `smarthelp-error-search|filter-type|${documentType}`;
        trackSetUp(trackLinkOption);
        dispatch(receiveArticleSearchError(searchTerm, experience, documentType));
        searchAnalytics(searchParser({
          count: 0, type: searchType.fullSearch, query: searchTerm, csrf: Page.getCSRFtoken(),
        }));
      });
  };
};
